import React, { FC } from "react";
import { Container } from './styles';

export type Props = {
  children?: React.ReactNode;
};

const ToolbarMenuItem: FC<Props> = (props) => {
  return (
    <Container>
      {props.children}
    </Container>
  );
};

export default ToolbarMenuItem;
